import { createBrowserRouter, Outlet } from 'react-router-dom'
import { useGoogleAnalyticsUserId, useTrackPageView } from '@/app/analytics'
import { requireAuthentication, rootLoader } from '@/app/auth/routeLoaders'
import { RouteErrorElement } from '@/app/router/RouteErrorElement'
import { RootLayout } from './layout/RootLayout'

const RootElement = () => {
  useGoogleAnalyticsUserId()
  useTrackPageView()

  return <Outlet />
}

const memberOnlyPages = [
  {
    path: '/',
    loader: rootLoader,
  },
  {
    path: '/login',
    lazy: () => import('@/pages/landing-page'),
  },
  {
    loader: requireAuthentication,
    element: <Outlet />,
    shouldRevalidate: () => true,
    children: [
      {
        path: '/home',
        lazy: () => import('@/pages/home'),
        handle: { showPersistentVrmViewer: true },
        children: [
          {
            path: 'meals/:mealId',
            lazy: () => import('@/pages/home/MealLogDetail'),
          },
        ],
      },
      {
        path: '/training/menu',
        lazy: () => import('@/pages/training-menu'),
        handle: { globalBodyPreset: 'training-menu' as const, showPersistentVrmViewer: true },
      },
      {
        path: '/training/session',
        lazy: () => import('@/pages/training-session'),
        handle: { globalBodyPreset: 'training-session' as const, showPersistentVrmViewer: true },
      },
      {
        path: '/meal-logs',
        lazy: () => import('@/pages/meal-logs/MealLogs'),
        handle: { showPersistentVrmViewer: true },
      },
    ],
  },
  {
    path: '/logout',
    lazy: () => import('@/pages/debug/Logout.tsx'),
  },
]

export default createBrowserRouter([
  {
    element: <RootElement />,
    errorElement: <RouteErrorElement />,
    children: [
      {
        element: <RootLayout />,
        children: [...memberOnlyPages],
      },
      {
        path: '/legal',
        lazy: () => import('@/pages/legal'),
      },
    ],
  },
])
